import call from "../dashboard/service/http";
import constants from "./AppConstants.js";
import AuthService from "../dashboard/modules/auth/AuthService";

export default {
  namespaced: true,
  state: {
    setupProgrammes: [],
    applicationDocument: "",
    admissionLetter: "",
    studentTimetable: "",
    serviceRequest: {},
    application: {},
    applications: [],
    proforma: "",
    receipt: "",
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    appGetters: (state) => (value) => state[value],
  },
  actions: {
    getSetupProgrammes: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.setupProgrammes)
        .then((res) => {
          commit("MUTATE", { state: "setupProgrammes", data: res.data.data });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getApplications: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.applications(data))
        .then((res) => {
          commit("MUTATE", {
            state: "application",
            data: res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getAllApplications: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.applications(data))
        .then((res) => {
          commit("MUTATE", {
            state: "applications",
            data: res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getApplicationDocument: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.applicationDocument(data))
        .then((res) => {
          commit("MUTATE", {
            state: "applicationDocument",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getAdmissionLetter: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.admissionLetter(AuthService.user.profile_id))
        .then((res) => {
          commit("MUTATE", {
            state: "admissionLetter",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getStudentTimetable: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call(
        "get",
        constants.studentTimetable(
          AuthService.user.profile.identificationDocumentNo,
        ),
      )
        .then((res) => {
          commit("MUTATE", {
            state: "studentTimetable",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getApplicationProforma: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.proforma(data))
        .then((res) => {
          commit("MUTATE", {
            state: "proforma",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getReceipt: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.receipt(data))
        .then((res) => {
          commit("MUTATE", {
            state: "receipt",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    getServiceRequest: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.serviceRequest(data))
        .then((res) => {
          commit("MUTATE", {
            state: "serviceRequest",
            data: res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("route-change", { name: "Payments" });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    updateApplication: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.application, data)
        .then((res) => {
          Event.$emit("ApiSuccess", "Application Submitted Successfully");
          localStorage.setItem("applicationNo", res.data.data.applicationNo);
          setTimeout(() => {
            Event.$emit("changeAppStatus");
          }, 5000);
          commit("Dashboard/SET_LOADING", false, { root: true });
          AuthService.setApplicant(res.data.data);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    patchApplication: ({ commit, dispatch }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.patchApplication, data)
        .then((res) => {
          dispatch("getAllApplications", res.data.data.shift().profileID);
          Event.$emit("ApiSuccess", "Successfully Resubmitted");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
